import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";

interface IOrderCount {
    count: number;
}

export function useOrderBacklog(isMountDisabled?: boolean) {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId)
    const { apiData, isLoading, callAPI } = useAPIV2<IOrderCount>(APIExtensions.placedOrders, { query: 'collection_point/backlog/count', yoelloAPIParams: { venue_id: selectedVenueId }, onMountDisabled: isMountDisabled ?? false });

    async function checkOrderBacklog() {
        return await callAPI(HTTPMethods.GET);
    }

    return { apiData: apiData !== null ? apiData.count : null, isLoading, checkOrderBacklog: checkOrderBacklog };
}
